<template>
  <div>
    <transition
      enter-active-class="dwp-transition-opacity dwp-ease-in-out dwp-duration-200"
      enter-class="dwp-opacity-0"
      enter-to-class="dwp-opacity-75"
      leave-active-class="dwp-transition-opacity dwp-ease-in-out dwp-duration-200"
      leave-class="dwp-opacity-75"
      leave-to-class="dwp-opacity-0"
    >
      <div>
        <div
          v-if="open"
          data-cy="close-menu-overlay"
          class="dwp-absolute dwp-inset-0 dwp-bg-gray-400 dwp-z-40 dwp-opacity-75"
          @click="open = false"
        ></div>
      </div>
    </transition>
    <div
      class="dwp-overflow-hidden dwp-rounded dwp-absolute dwp-z-40 dwp-h-full"
      style="max-width: 295px"
    >
      <transition
        enter-active-class="dwp-transform dwp-transition dwp-ease-in-out dwp-duration-200"
        enter-class="dwp--translate-x-full"
        enter-to-class="dwp-translate-x-0"
        leave-active-class="dwp-transform dwp-transition dwp-ease-in-out dwp-duration-200"
        leave-class="dwp-translate-x-0"
        leave-to-class="dwp--translate-x-full"
      >
        <div
          v-if="open"
          class="dwp-h-full dwp-flex-1 dwp-flex dwp-flex-col dwp-w-full dwp-bg-white dwp-shadow-lg dwp-border-r dwp-border-gray-300"
        >
          <div class="dwp-flex-1 dwp-h-0 dwp-overflow-y-auto">
            <div class="dwp-px-8 dwp-mt-6 dwp-flex dwp-items-center">
              <span class="dwp-relative dwp-z-0 dwp-inline-flex dwp-shadow-sm dwp-rounded-md">
                <button
                  @click.prevent="addNew"
                  type="button"
                  class="dwp-relative dwp-inline-flex dwp-whitespace-no-wrap dwp-items-center dwp-px-4 dwp-py-2 dwp-rounded-l-md dwp-border dwp-border-primary dwp-bg-primary dwp-text-sm dwp-leading-5 dwp-font-medium dwp-text-white hover:dwp-text-primary-200 focus:dwp-z-10 focus:dwp-outline-none focus:dwp-border-blue-300 focus:dwp-shadow-outline-blue active:dwp-bg-gray-100 active:dwp-text-gray-700 dwp-transition dwp-ease-in-out dwp-duration-150"
                >
                  <PlusIcon class="dwp-w-3 dwp-mr-1" stroke-width="3" />New List
                </button>
                <button
                  @click.prevent="importModal = true"
                  type="button"
                  data-cy="list-import"
                  class="dwp--ml-px dwp-relative dwp-whitespace-no-wrap dwp-inline-flex dwp-items-center dwp-px-4 dwp-py-2 dwp-rounded-r-md dwp-border dwp-border-gray-300 dwp-bg-white dwp-text-sm dwp-leading-5 dwp-font-medium dwp-text-gray-700 hover:dwp-text-gray-500 focus:dwp-z-10 focus:dwp-outline-none focus:dwp-border-blue-300 focus:dwp-shadow-outline-blue active:dwp-bg-gray-100 active:dwp-text-gray-700 dwp-transition dwp-ease-in-out dwp-duration-150"
                >
                  <DownloadCloudIcon class="dwp-w-3 dwp-mr-1 dwp-opacity-75" stroke-width="3" />Import List
                </button>
              </span>
            </div>
            <div
              class="dwp-mt-5 dwp-border-t dwp-border-gray-300 dwp-py-4"
              data-cy="published-lists"
            >
              <div class="dwp-px-8 dwp-text-sm dwp-text-gray-500 dwp-mb-2">{{ projectName }} Lists</div>
              <template v-if="Object.keys(publishedLists).length">
                <template v-for="item in publishedLists">
                  <List
                    :list="item"
                    :key="item.id"
                    @click.native.prevent="currentList = item; open = false;"
                  />
                </template>
              </template>
              <div
                v-else
                class="dwp-text-xs dwp-px-8 dwp-py-2 dwp-flex dwp-text-gray-500 dwp-items-center dwp-truncate dwp-rounded-r-full dwp-mr-6 dwp-space-x-2"
              >
                <span>No Lists</span>
              </div>
            </div>
            <div class="dwp-border-t dwp-border-gray-300 dwp-py-4">
              <div
                @click.prevent="tab = 'archived'"
                data-cy="show-archived"
                class="dwp-px-8 dwp-py-2 dwp-flex dwp-text-gray-800 dwp-items-center dwp-text-sm dwp-truncate dwp-cursor-pointer dwp-rounded-r-full dwp-mr-6 dwp-space-x-2"
              >
                <ArchiveIcon
                  class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-text-gray-500"
                  style="fill:none"
                />
                <span>Archived Lists</span>
              </div>
              <div
                @click.prevent="tab = 'trashed'"
                data-cy="show-trashed"
                class="dwp-px-8 dwp-py-2 dwp-flex dwp-text-gray-800 dwp-items-center dwp-text-sm dwp-truncate dwp-cursor-pointer dwp-rounded-r-full dwp-mr-6 dwp-space-x-2"
              >
                <TrashIcon
                  class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-text-gray-500"
                  style="fill:none"
                />
                <span>Trashed Lists</span>
              </div>
            </div>
          </div>
          <div
            class="dwp-flex-shrink-0 dwp-flex dwp-items-center dwp-px-8 dwp-py-4 dwp-border-t dwp-border-gray-300"
          >
            <a
              @click.prevent="signOut"
              class="dwp-flex dwp-space-x-2 dwp-group dwp-items-center dwp-truncate dwp-cursor-pointer dwp-select-none dwp-text-sm dwp-leading-5 dwp-text-gray-700 hover:dwp-bg-gray-100 hover:dwp-text-gray-900 focus:dwp-outline-none focus:dwp-bg-gray-100 focus:dwp-text-gray-900"
              role="menuitem"
            >
              <LogOutIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
              <div>Sign Out</div>
            </a>
          </div>

          <transition
            enter-active-class="dwp-transform dwp-transition dwp-ease-in-out dwp-duration-200"
            enter-class="dwp--translate-x-full"
            enter-to-class="dwp-translate-x-0"
            leave-active-class="dwp-transform dwp-transition dwp-ease-in-out dwp-duration-200"
            leave-class="dwp-translate-x-0"
            leave-to-class="dwp--translate-x-full"
          >
            <ArchivedLists
              class="dwp-absolute dwp-top-0 dwp-left-0 dwp-right-0 dwp-bottom-0 dwp-h-full dwp-flex-1 dwp-flex dwp-flex-col dwp-w-full dwp-bg-white dwp-shadow-lg dwp-border-r dwp-border-gray-300"
              v-if="tab == 'archived'"
            />
            <TrashedLists
              class="dwp-absolute dwp-top-0 dwp-left-0 dwp-right-0 dwp-bottom-0 dwp-h-full dwp-flex-1 dwp-flex dwp-flex-col dwp-w-full dwp-bg-white dwp-shadow-lg dwp-border-r dwp-border-gray-300"
              v-if="tab == 'trashed'"
            />
          </transition>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import {
  PlusIcon,
  ArrowLeftIcon,
  UploadCloudIcon,
  ArchiveIcon,
  LogOutIcon,
  DownloadCloudIcon,
  EditIcon,
  TrashIcon,
} from "vue-feather-icons";

import List from "./List.vue";

import { sync, call } from "vuex-pathify";
import currentList from "@/mixins/current-list";

export default {
  mixins: [currentList],

  components: {
    PlusIcon,
    DownloadCloudIcon,
    EditIcon,
    List,
    ArchiveIcon,
    LogOutIcon,
    TrashIcon,
    UploadCloudIcon,
    ArrowLeftIcon,
    VButton,
    ArchivedLists: () => import("./ArchivedLists.vue"),
    TrashedLists: () => import("./TrashedLists.vue"),
  },

  computed: {
    open: sync("ui/menu@open"),
    tab: sync("ui/menu@tab"),
    newModal: sync("ui/modal@list.new.open"),
    importModal: sync("ui/modal@list.import.open"),
    projectName() {
      return docketData?.sitename || "This Project's";
    },
    publishedLists() {
      return this.filterObject(this.lists, (list) => {
        return list.status == "published";
      });
    },
  },

  watch: {
    async open(val) {
      if (!val) {
        this.tab = null;
      }
    },
  },

  methods: {
    ...call("user", ["signOut"]),
    addNew() {
      this.newModal = true;
    },
    percentage(list) {
      if (!list?.counts?.total || !list?.counts?.done) {
        return 0;
      }
      return (list.counts.done / list.counts.total) * 100;
    },
  },
};
</script>